import { Navigate, Outlet, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const RequireAuth = ({ allowedRoles }) => {
  let token = localStorage.getItem("token");
  const location = useLocation();

  if (token) {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    // Token is valid only if decodedToken.exp > currentTime
    if (decodedToken.exp > currentTime) {
      return allowedRoles.some((role) => decodedToken?.role?.includes(role)) ? (
        <Outlet />
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      );
    } else {
      // Token expired
      return <Navigate to="/" state={{ from: location }} replace />;
    }
  }

  // No token found
  return <Navigate to="/" state={{ from: location }} replace />;
};

export const getRoles = () => {
  let token = localStorage.getItem("token");

  if (token) {
    const decodedToken = jwtDecode(token);
    return decodedToken.role || [];
  }

  return [];
};

export const user_name = () => {
  let token = localStorage.getItem("token");

  if (token) {
    const decodedToken = jwtDecode(token);
    return decodedToken.user_name || "";
  }

  return "";
};
export const role = () => {
  let role = localStorage.getItem("role");

  if (role) {
    const decodedToken = jwtDecode(role);
    return decodedToken.role || "";
  }

  return "";
};

export default RequireAuth;
